<template>
    <div class="columns-2 md:columns-4 xl:columns-6 gap-8">
        <div v-for="index in 20" :key="index" class="mb-10 opacity-20 animate-pulse inline-block w-full">
            <div class="items-center justify-center w-full bg-white rounded flex"
                 :class="Math.random() > 0.5 ? 'h-48' : 'h-96'">
                <svg class="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor" viewBox="0 0 20 18">
                    <path
                        d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                </svg>
            </div>
            <div class="py-1 mt-3">
                <div class="h-2.5 bg-white rounded-full mt-3 mb-2 w-2/3"></div>
            </div>
            <div class="h-2 bg-gray-200 rounded-full w-full mt-6 mb-2"></div>
            <div class="h-2 bg-gray-200 rounded-full w-full"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MoleculeSkeletonCard'
}
</script>
